import { defineMessages } from 'react-intl';

const riskIntelligenceTranslations = defineMessages({
    ng_common_riskIntelligence: {
        id: 'ng_common_riskIntelligence',
        defaultMessage: 'Risk Intelligence'
    },
    ng_common_eventFeed: {
        id: 'ng_common_eventFeed',
        defaultMessage: 'Event Feed'
    },
    ng_common_explore: {
        id: 'ng_common_explore',
        defaultMessage: 'Explore'
    },
    ng_common_admin: {
        id: 'ng_common_admin',
        defaultMessage: 'Admin'
    },
    ng_common_travel: {
        id: 'ng_common_travel',
        defaultMessage: 'Travel'
    },
    ng_common_communicationMethods: {
        id: 'ng_common_communicationMethods',
        defaultMessage: 'Communication Methods'
    },
    ng_common_filters: {
        id: 'ng_common_filters',
        defaultMessage: 'Filters'
    }
});

export default riskIntelligenceTranslations;
